var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _path3, _path4, _circle, _path5, _circle2, _path6, _circle3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorBoundaryXs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 78,
    viewBox: "0 0 178 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.9482,
    width: 88.6214,
    height: 56.2676,
    rx: 1,
    fill: "#EFADA8",
    fillOpacity: 0.57
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 77.4214,
    y: 11.2535,
    width: 93.5449,
    height: 53.4542,
    rx: 1,
    fill: "url(#paint0_linear_29_2339)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 89.3784,
    y: 21.1003,
    width: 88.6214,
    height: 56.2676,
    rx: 1,
    fill: "url(#paint1_linear_29_2339)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 92.8955,
    y: 25.6135,
    width: 5.62676,
    height: 5.34889,
    rx: 1,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 101.335,
    y: 25.6135,
    width: 5.62676,
    height: 5.34889,
    rx: 1,
    fill: "white",
    fillOpacity: 0.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 109.775,
    y: 25.6135,
    width: 5.62676,
    height: 5.34889,
    rx: 1,
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 155.493,
    y: 25.6135,
    width: 19.6937,
    height: 5.26532,
    rx: 1,
    fill: "#FFB6C3",
    fillOpacity: 0.45
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.578 49.2215L131.967 57.1541H133.286L133.692 49.2215H131.578Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.881 59.9435C132.083 60.1457 132.326 60.2467 132.609 60.2467C132.879 60.2467 133.116 60.1468 133.32 59.947C133.525 59.7472 133.627 59.5055 133.627 59.2221C133.627 58.9339 133.526 58.6911 133.324 58.4936C133.122 58.2961 132.883 58.1974 132.609 58.1974C132.326 58.1974 132.083 58.2973 131.881 58.4971C131.679 58.6969 131.578 58.9386 131.578 59.2221C131.578 59.5009 131.679 59.7414 131.881 59.9435Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.634 41.6072C133.527 41.6072 134.348 42.0949 134.776 42.8787L144.535 60.77C144.947 61.5259 144.931 62.4432 144.491 63.1837C144.051 63.9241 143.254 64.378 142.393 64.378H122.875C122.014 64.378 121.217 63.9241 120.777 63.1837C120.338 62.4432 120.321 61.5259 120.733 60.77L130.492 42.8787C130.92 42.0949 131.741 41.6072 132.634 41.6072ZM122.875 61.9383H142.393L132.634 44.0469L122.875 61.9383Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0376 20.8727L49.4244 20.8727",
    stroke: "#D30602",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2597,
    cy: 20.8726,
    r: 1.66981,
    fill: "#D30602"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 34.2311L36.9009 34.2311",
    stroke: "#D30602",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5707,
    cy: 34.2311,
    r: 1.66981,
    fill: "#D30602"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5425 45.0849L43.5802 45.0849",
    stroke: "#D30602",
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.2499,
    cy: 45.0849,
    r: 1.66981,
    fill: "#D30602"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_2339",
    x1: 77.4214,
    y1: 23.2104,
    x2: 224.42,
    y2: -18.9903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE93A3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29_2339",
    x1: 139.316,
    y1: 77.3679,
    x2: 91.0499,
    y2: 28.5899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B32A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B32A3A",
    stopOpacity: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBoundaryXs);
export default __webpack_public_path__ + "static/media/error_boundary_xs.067a8cf7ba6db30def0a622c21fe0a4a.svg";
export { ForwardRef as ReactComponent };